import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { NavigationService } from "../../navigation.service";

@Component({
  selector: "provider-panel-navigation",
  templateUrl: "provider-panel-navigation.html",
})
export class ProviderPanelNavigation {
  @Output()
  navigated = new EventEmitter<string>();
  private _activePage: string = "ProviderPanelPage";

  constructor(
    public navCtrl: NavController,
    private navigationService: NavigationService,
    public navParams: NavParams
  ) {}

  ionViewDidLoad() {}

  redirectPage(page: string) {
    this.navigationService.goToInternalPage(page, this.navParams);
  }

  @Input()
  set activePage(value: string) {
    this._activePage = value;
  }
  get activePage(): string {
    return this._activePage;
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/provider-panel-navigation/provider-panel-navigation.ts